// extracted by mini-css-extract-plugin
export default {"buttons":"FloatBar_buttons__irUDl"};